import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const errors = {
	state: {	
		favoritos : []
	},
	getters: {		
		getFavoritos : state => state.favoritos
	},
	actions: {
		toggleFavoritos : function({commit,state},el){

			let id = (!!el.idPractica) ? 'idPractica' : 'urlAcceso';

			let exits = state.favoritos.some(e => e[id] == el[id]);

			(exits) ? commit('removeFavorito',el) : commit('addFavorito',el);
		}
	},
	mutations: {
		setFavoritos(state){
			if(!!window.localStorage.getItem('favs')){
				state.favoritos = JSON.parse(window.localStorage.getItem('favs'));
			}
		},
		addFavorito(state,el){

			let id = (!!el.idPractica) ? 'idPractica' : 'urlAcceso';
			let type = (!!el.idPractica) ? 'practica' : 'aprobacion';
			let empresa = (!!el.nombreEmpresa) ? 'nombreEmpresa' : 'nombreComercialEmpresa';
			let estudiante = (!!el.nombreEstudiante) ? 'nombreEstudiante' : 'puesto';


			let ele = {
				idPractica : el[id],
				nombreEstudiante : el[estudiante],
				nombreEmpresa : el[empresa],
				puesto : el.puesto,
				type : type
			};

			console.log(ele);

			state.favoritos.push(ele);
			window.localStorage.setItem('favs', JSON.stringify(state.favoritos));
		},
		removeFavorito(state,el){
			let favs = new Array();

			state.favoritos.forEach(e => {
				if(e.idPractica != el.idPractica){
					favs.push(e);
				}
			})

			state.favoritos = favs;

			window.localStorage.setItem('favs', JSON.stringify(state.favoritos));
		}
	}
}

export default errors;



// WEBPACK FOOTER //
// ./src/store/favoritos.js